import axios from 'axios'
import { extractError } from '../utils/errorHandler'

export const getAll = async () => {
  try {
    const { data } = await axios.get('customPage')
    return data
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}

export const getById = async (id) => {
  try {
    const { data } = await axios.get(`customPage/${id}`)
    return data
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}

export const create = async (customPage) => {
  try {
    const { data } = await axios.post('customPage', customPage)
    return data
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}

export const update = async (customPage) => {
  try {
    const { data } = await axios.put(`customPage/${customPage.id}`, customPage)
    return data
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}

export const updateData = async (id, dataToUpdate) => {
  try {
    const { data } = await axios.patch(`customPage/${id}/data`, dataToUpdate)
    return data
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}

export const remove = async (id) => {
  try {
    await axios.delete(`customPage/${id}`)
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}
